/** The old workflow value is accepted at boundaries, but new writes use 出荷依頼. */
export function isShippingRequestStatus(value: string | null | undefined): boolean {
  return value?.trim() === "出荷依頼" || value?.trim() === "出荷済み";
}

export function normalizeShippingRequestStatus<T extends string | null | undefined>(value: T): T | "出荷依頼" {
  return isShippingRequestStatus(value) ? "出荷依頼" : value;
}
